import { DocTiles } from "../files/doc-tiles";
import { DocList } from "../files/doc-list";
import { useState, useEffect, useMemo } from "react";
import { useMsal, } from '@azure/msal-react';
import DocsAPI from "../../api/docs/docs-api-factory";
import { arrayAny } from "../../utils/arrayUtils";

export const LandlordDocumentsTab = ({ landlord }) => {

    const tabName = "Documents";

    const { instance, inProgress, accounts } = useMsal();
    const [data, setData] = useState(null);
    const [fetchDocTypesInProgress, setFetchDocTypesInProgress] = useState(false);
    const [shouldFetch, setShouldFetch] = useState(true);
    const [showDelete, setShowDelete] = useState(false);
    const [viewMode, setViewMode] = useState('grid'); // 'grid' or 'list'
    
    // Create API instance using useMemo to prevent unnecessary recreation
    const api = useMemo(() => new DocsAPI(instance, inProgress, accounts), [instance, inProgress, accounts]);

    useEffect(() => {
        const fetchDocTypes = async () => {
            if (shouldFetch && !fetchDocTypesInProgress) {
                setFetchDocTypesInProgress(true);
                
                try {
                    const data = await api.getAll(['landlord']); // Fetch doc types related to this screen
                    setData(data);
                } catch (error) {
                    console.error("An error occurred fetching data.", error);
                } finally {
                    setFetchDocTypesInProgress(false);
                    setShouldFetch(false);
                }
            }
        };
        
        fetchDocTypes();
    }, [api, shouldFetch, fetchDocTypesInProgress]);
    

    const showButtons = () => {
        return landlord && arrayAny(landlord.documents);
    };

    const toggleViewMode = (mode) => {
        setViewMode(mode);
    };

    return (
        <>
            <div className="d-flex">
                <h3 className="mt-10px">{tabName}</h3>
                <div className="mt-10px ms-auto d-flex">
                    {/* View toggle buttons */}
                    <div className="btn-group me-2">
                        <button 
                            className={`btn btn-sm ${viewMode === 'grid' ? 'btn-primary' : 'btn-outline-primary'}`}
                            onClick={() => toggleViewMode('grid')}
                        >
                            <i className="fas fa-th-large"></i>
                        </button>
                        <button 
                            className={`btn btn-sm ${viewMode === 'list' ? 'btn-primary' : 'btn-outline-primary'}`}
                            onClick={() => toggleViewMode('list')}
                        >
                            <i className="fas fa-list"></i>
                        </button>
                    </div>
                    
                    {/* Delete button */}
                    {showButtons() &&
                        <div className="btn-group">
                            <button className="btn btn-success btn-rounded px-4 rounded-pill btn-red" onClick={() => setShowDelete(!showDelete)}>
                                <i className="fas fa-fw fa-lg me-10px fa-trash-can ms-n2 "></i>Delete Documents
                            </button>
                        </div>
                    }
                </div>
            </div>
            
            {/* Conditionally render either grid view or list view based on viewMode */}
            {viewMode === 'grid' ? (
                <DocTiles
                    docs={landlord.documents}
                    docTypes={data}
                    documentHolder={landlord}
                    showDelete={showDelete}
                    containerName={landlord.parent.name}
                    contextType="landlord"
                />
            ) : (
                <DocList
                    docs={landlord.documents}
                    docTypes={data}
                    documentHolder={landlord}
                    showDelete={showDelete}
                    containerName={landlord.parent.name}
                    contextType="landlord"
                />
            )}
        </>
    );
};